export const rankList = [
  { id: 'rk-1', rank: 1, title: '星河以北', type: '电视剧', heat: '9862', trend: 'up' },
  { id: 'rk-2', rank: 2, title: '长夜微光', type: '电视剧', heat: '9140', trend: 'up' },
  { id: 'rk-3', rank: 3, title: '海上列车', type: '电影', heat: '8733', trend: 'flat' },
  { id: 'rk-4', rank: 4, title: '归海', type: '电视剧', heat: '8420', trend: 'up' },
  { id: 'rk-5', rank: 5, title: '尘世微光', type: '电影', heat: '8155', trend: 'down' },
  { id: 'rk-6', rank: 6, title: '第七码头', type: '电视剧', heat: '7902', trend: 'up' },
  { id: 'rk-7', rank: 7, title: '暗涌', type: '电影', heat: '7644', trend: 'flat' },
  { id: 'rk-8', rank: 8, title: '月落长安', type: '电视剧', heat: '7310', trend: 'down' },
  { id: 'rk-9', rank: 9, title: '星尘信笺', type: '电影', heat: '7088', trend: 'up' },
  { id: 'rk-10', rank: 10, title: '逆风而行', type: '电视剧', heat: '6821', trend: 'flat' },
];